import React from "react";

import { Divider, MenuItem, TextField } from "@mui/material";

import { groupOperators } from "@/utils";

interface QueryGroupOperatorProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const QueryGroupOperator: React.FC<QueryGroupOperatorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <Divider>
      <TextField
        size="small"
        color="secondary"
        select
        value={value}
        onChange={onChange}
        sx={{ minWidth: "80px" }}
        disabled={disabled}
      >
        {groupOperators.map((operator) => (
          <MenuItem key={operator} value={operator}>
            {operator}
          </MenuItem>
        ))}
      </TextField>
    </Divider>
  );
};

export default QueryGroupOperator;
